import type { MouseEvent, ReactNode } from 'react';

export type PageLayoutSubtitlePosition = 'top' | 'bottom';

export type PageLayoutProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  subtitlePosition?: PageLayoutSubtitlePosition;
  status?: ReactNode;
  action?: ReactNode;
  backHref?: string;
  onBackClick?: (event: MouseEvent<HTMLElement>) => void;
  backLabel?: string;
  fixedHeader?: boolean;
  children?: ReactNode;
};

export function usePageLayout(props: PageLayoutProps) {
  const subtitlePosition = props.subtitlePosition ?? 'bottom';
  const hasSubtitle = props.subtitle !== undefined && props.subtitle !== null && props.subtitle !== '';

  return {
    fixedHeader: props.fixedHeader ?? false,
    backLabel: props.backLabel ?? 'Retour',
    showSubtitleTop: hasSubtitle && subtitlePosition === 'top',
    showSubtitleBottom: hasSubtitle && subtitlePosition === 'bottom',
  };
}
